import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { getActiveBanner } from '../features/landing/bannerApi';
import { useLocalizedText } from '../lib/localized-text';

export function GlobalAnnouncementBanner() {
  const { t } = useTranslation();
  const localize = useLocalizedText();
  const [dismissedId, setDismissedId] = useState<string | null>(null);
  const { data: banner } = useQuery({
    queryKey: ['active-banner'],
    queryFn: getActiveBanner,
    staleTime: 5 * 60 * 1000,
  });

  if (!banner || banner.id === dismissedId) return null;

  return (
    <div className="relative bg-manuscript-ink font-manuscript">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-x-2 px-10 py-2.5 text-center text-sm text-paper-50">
        <span>{localize(banner.message)}</span>
      </div>
      <button
        type="button"
        onClick={() => setDismissedId(banner.id)}
        aria-label={t('promoBanner.dismiss')}
        className="absolute right-2 top-1/2 -translate-y-1/2 rounded-sm p-1.5 text-paper-50/80 hover:text-paper-50"
      >
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M18 6 6 18M6 6l12 12" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
    </div>
  );
}
